import { Component, createContext, createElement } from 'react';
import { UserManager } from 'oidc-client';

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
} // A type of promise-like that resolves synchronously and supports only one observer


var _iteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";

var _asyncIteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously call a function and send errors to recovery continuation


function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var RedirectToAuth = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(RedirectToAuth, _React$Component);

  function RedirectToAuth() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = RedirectToAuth.prototype;

  _proto.componentDidMount = function componentDidMount() {
    try {
      var _this2 = this;

      var _temp3 = function () {
        if (_this2.props.userManager.signinSilent) {
          var _temp4 = _catch(function () {
            return Promise.resolve(_this2.props.userManager.signinSilent(_this2.props.signinArgs)).then(function (user) {
              _this2.props.onSilentSuccess(user);
            });
          }, function () {
            _this2.props.userManager.signinRedirect(_this2.props.signinArgs);
          });

          if (_temp4 && _temp4.then) return _temp4.then(function () {});
        } else {
          _this2.props.userManager.signinRedirect(_this2.props.signinArgs);
        }
      }();

      return Promise.resolve(_temp3 && _temp3.then ? _temp3.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.render = function render() {
    return this.props.children || null;
  };

  return RedirectToAuth;
}(Component);

var UserService = /*#__PURE__*/function () {
  function UserService() {}

  var _proto = UserService.prototype;

  _proto.getUserInfo = function getUserInfo() {
    var getUser = localStorage.getItem('user');
    var user;

    if (getUser) {
      user = JSON.parse(getUser);
    } else {
      user = {};
    }

    return user;
  };

  _proto.clearUserInfo = function clearUserInfo() {
    return localStorage.removeItem('user');
  };

  return UserService;
}();

var TokenService = /*#__PURE__*/function () {
  function TokenService() {}

  var _proto = TokenService.prototype;

  _proto.padBase64 = function padBase64(base64data) {
    while (base64data.length % 4 !== 0) {
      base64data += '=';
    }

    return base64data;
  };

  _proto.deserializeClaims = function deserializeClaims(raw) {
    var claimsBase64 = this.padBase64(raw);
    var claimsJson = atob(claimsBase64);
    var claims = JSON.parse(claimsJson);
    return claims;
  };

  _proto.getPayloadFromRawToken = function getPayloadFromRawToken(raw) {
    var tokenParts = raw.split('.');
    return tokenParts[1];
  };

  _proto.convertToClaims = function convertToClaims(idToken) {
    var payload = this.getPayloadFromRawToken(idToken);
    var claims = this.deserializeClaims(payload);
    return claims;
  };

  _proto.saveToken = function saveToken(idToken) {
    localStorage.setItem('idToken', idToken);
    var idClaims = this.convertToClaims(idToken);
    localStorage.setItem('cached-claims', JSON.stringify(idClaims));
  };

  _proto.saveAccessToken = function saveAccessToken(accessToken) {
    var idClaims = this.convertToClaims(accessToken);
    localStorage.setItem('user-profile', JSON.stringify(idClaims));
  };

  _proto.getIdToken = function getIdToken() {
    var idToken = localStorage.getItem('idToken');

    if (idToken) {
      return localStorage.getItem('idToken');
    } else {
      return '';
    }
  };

  _proto.allClaims = function allClaims() {
    var cachedClaims = localStorage.getItem('cached-claims');

    if (cachedClaims) {
      var idToken = this.getIdToken();

      if (idToken) {
        var claims = this.convertToClaims(idToken);
        localStorage.setItem('cached-claims', claims);
        return claims;
      }
    }

    return cachedClaims;
  };

  _proto.hasToken = function hasToken() {
    var claims = this.allClaims();

    if (!(claims && claims.hasOwnProperty('iat') && claims.hasOwnProperty('exp'))) {
      return false;
    }

    return true;
  };

  _proto.hasValidToken = function hasValidToken() {
    if (!this.hasToken()) {
      return false;
    }

    var claims = this.allClaims();
    var now = Date.now();
    var issuedAtMSec = claims.iat * 1000;
    var expiresAtMSec = claims.exp * 1000;
    var marginMSec = 1000 * 60 * 5;

    if (issuedAtMSec - marginMSec > now) {
      return false;
    }

    if (expiresAtMSec < now) {
      return false;
    }

    return true;
  };

  _proto.clearTokens = function clearTokens() {
    localStorage.removeItem('cached-claims');
    localStorage.removeItem('idToken');
  };

  return TokenService;
}();

var TokenManagerService = /*#__PURE__*/function () {
  function TokenManagerService() {
    this.userService = new UserService();
    this.authFn = new authFn();
    this.proccessing = {};
  }

  var _proto2 = TokenManagerService.prototype;

  _proto2.checkValidToken = function checkValidToken() {
    var user = this.userService.getUserInfo();

    if (!user && Object.keys(user).length > 0) {
      return 0;
    }

    var expiresIn = user.expires;
    var currentT = new Date().getTime();
    var expireTime = parseInt(user.ExpiresIn);
    var diffTime = expiresIn - currentT;

    if (diffTime < 0 || isNaN(diffTime)) {
      return 0;
    } else if (diffTime / (expireTime * 1000) <= 0.05 || diffTime < 10000) {
      return 1;
    } else {
      return diffTime;
    }
  };

  _proto2.getNewToken = function getNewToken(conf) {
    var now = new Date().getTime();
    this.proccessing = {};
    this.proccessing['status'] = 'processing';
    this.proccessing['history'] = now;
    localStorage.setItem('tokenProcessing', JSON.stringify(this.proccessing));
    var res = this.authFn.startImplicitFlow(conf);
    return res;
  };

  _proto2.refreshToken = function refreshToken() {
    var now = new Date().getTime();
    this.proccessing = {};
    this.proccessing['status'] = 'processing';
    this.proccessing['history'] = now;
    localStorage.setItem('tokenProcessing', JSON.stringify(this.proccessing));
    return;
  };

  _proto2.checkingIsRequestingToken = function checkingIsRequestingToken(bufferTime) {
    var user = this.userService.getUserInfo();
    var now = new Date().getTime();
    var expiresIn = new Date(user.Expires).getTime();
    var remainingTime = expiresIn - now;

    if (remainingTime / 1000 > bufferTime) {
      return true;
    }

    var getProccessing = localStorage.getItem('tokenProcessing');

    if (getProccessing) {
      var proccessing = JSON.parse(getProccessing);
    }

    if (Object.keys(proccessing).length === 0) {
      return false;
    }

    if (now - proccessing.history >= 3000) {
      this.removeRefreshToken();
      return false;
    } else {
      return true;
    }
  };

  _proto2.removeRefreshToken = function removeRefreshToken() {
    localStorage.removeItem('tokenProcessing');
  };

  _proto2.logoutFn = function logoutFn(conf) {
    this.authFn.startLogout(conf);
  };

  return TokenManagerService;
}();

function makeUserManager(config, umClass) {
  var UMClass = umClass || UserManager;
  return new UMClass(config);
}

var defaultConfiguration = {
  redirect_uri: '',
  client_id: '',
  authority: '',
  response_type: '',
  scope: '',
  typeKey: 'token_type',
  tokenKey: 'access_token',
  idToken: 'id_token',
  loginRoute: '',
  afterLoginRedirectToRoute: '',
  unauthorizeRoute: '',
  inactivateUserCode: 409,
  apiUrl: '/api/',
  callbackRedirectUri: (window.location.origin || window.location.protocol + '//' + window.location.host) + window.location.pathname + '#/auth/callback/',
  logoutUri: (window.location.origin || window.location.protocol + '//' + window.location.host) + window.location.pathname + '#/auth/clear',
  state: '',
  authorizationEndpoint: 'connect/authorize',
  revocationEndpoint: 'connect/revocation',
  endSessionEndpoint: 'connect/endsession',
  advanceRefresh: 300,
  enableRequestChecks: false,
  stickToLastKnownIdp: false,
  expiresInKey: 'ExpiresIn',
  redirectCurrentLink: false
};

var AuthenticateService = /*#__PURE__*/function () {
  function AuthenticateService() {
    this.APIToken = {
      refreshIn: 0,
      refreshTokenTrigger: 0,
      refreshIdTokenTrigger: 0,
      isGettingToken: false,
      tokenStillValid: false,
      firstLoad: 0,
      bufferTime: 0,
      tokenMissing: false,
      tokenExpired: false,
      unauthorized: false
    };
    this.userService = new UserService();
    this.TokenManagerService = new TokenManagerService();
    this.TokenService = new TokenService();
    this.AuthChecking = new AuthChecking();
    this.authFn = new authFn();
  }

  var _proto = AuthenticateService.prototype;

  _proto.isLoggedin = function isLoggedin(conf) {
    var user = this.userService.getUserInfo();

    if (user[conf.tokenKey] !== undefined && user[conf.tokenKey].length > 10) {
      return true;
    } else {
      return false;
    }
  };

  _proto.getValidToken = function getValidToken() {
    var _this = this;

    var promise = new Promise(function (resolve) {
      if (_this.APIToken.isGettingToken === false && _this.APIToken.tokenStillValid === true) {
        resolve(_this.userService.getUserInfo().Token);
      }
    });
    return promise;
  };

  _proto.checkIfRefreshToken = function checkIfRefreshToken(conf) {
    this.triggerRegetNewIdToken(conf);
    var tokenIsValid = this.TokenManagerService.checkValidToken();

    if (tokenIsValid === 0) {
      this.APIToken.tokenStillValid = false;
    } else {
      this.APIToken.tokenStillValid = true;

      if (this.APIToken.firstLoad === 0) {
        this.AuthChecking.data.hasValidToken = true;
      }
    }

    var validIdToken = this.TokenService.hasValidToken();

    if (!validIdToken || !this.isLoggedin(conf)) {
      this.TokenManagerService.getNewToken(conf);
    } else if (tokenIsValid === 0 || tokenIsValid === 1) {
      this.TokenManagerService.refreshToken();
    } else {
      this.AuthChecking.data.hasValidToken = true;
      this.triggerRenewToken(tokenIsValid / 1000, conf);
    }
  };

  _proto.refreshToken = function refreshToken(conf) {
    if (!this.isLoggedin(conf)) {
      this.stopTrigger();
      return false;
    }

    var validIdToken = this.TokenService.hasValidToken();

    if (!validIdToken) {
      this.TokenManagerService.getNewToken(conf);
    } else if (this.TokenManagerService.checkingIsRequestingToken(this.APIToken.bufferTime) === false) {
      this.TokenManagerService.refreshToken();
    }

    return true;
  };

  _proto.triggerRenewToken = function triggerRenewToken(expiresIn, conf) {
    var _this2 = this;

    this.stopTrigger();
    var randomIntNumber = Math.floor(Math.random() * 20 + 1);
    this.APIToken.refreshIn = Math.floor(expiresIn) - Math.floor(0.05 * expiresIn);

    if (this.APIToken.refreshIn - randomIntNumber > 10) {
      this.APIToken.refreshIn = this.APIToken.refreshIn - randomIntNumber;
    }

    this.APIToken.bufferTime = Math.floor(expiresIn) - this.APIToken.refreshIn;
    var diff = this.APIToken.bufferTime * 1000;

    if (diff > Math.pow(2, 31)) {
      diff = Math.pow(2, 31) - 10;
    }

    if (typeof this.APIToken.refreshTokenTrigger !== undefined && !isNaN(this.APIToken.refreshIn)) {
      this.APIToken.refreshTokenTrigger = window.setInterval(function () {
        _this2.refreshToken(conf);
      }, diff);
    }
  };

  _proto.stopTrigger = function stopTrigger() {
    if (typeof this.APIToken.refreshTokenTrigger !== undefined) {
      clearInterval(this.APIToken.refreshTokenTrigger);
      this.APIToken.refreshTokenTrigger = 0;
    }
  };

  _proto.triggerRegetNewIdToken = function triggerRegetNewIdToken(conf) {
    var _this3 = this;

    this.stopIdTokenTrigger();
    var claims = this.TokenService.allClaims();
    var exp = claims.exp * 1000;
    var randomIntNumber = Math.floor(Math.random() * 20 + 1);
    var now = new Date().getTime();
    var diff = exp - now - randomIntNumber * 1000;

    if (diff > Math.pow(2, 31)) {
      diff = Math.pow(2, 31) - 10;
    }

    if (typeof this.APIToken.refreshIdTokenTrigger !== undefined && diff > 0) {
      this.APIToken.refreshIdTokenTrigger = window.setInterval(function () {
        var cf = confirm('Your session was expired! Do you want to relogin?');

        if (cf === true) {
          _this3.TokenManagerService.getNewToken(conf);

          if (conf.redirectCurrentLink) {
            var localRedirect = window.location.href;
            localStorage.setItem('localRedirect', localRedirect);
          }
        }
      }, diff);
    } else {
      var cf = confirm('Your session was expired! Do you want to relogin?');

      if (cf === true) {
        this.TokenManagerService.getNewToken(conf);

        if (conf.redirectCurrentLink) {
          var localRedirect = window.location.href;
          localStorage.setItem('localRedirect', localRedirect);
        }
      }
    }
  };

  _proto.stopIdTokenTrigger = function stopIdTokenTrigger() {
    if (typeof this.APIToken.refreshIdTokenTrigger !== undefined) {
      clearInterval(this.APIToken.refreshIdTokenTrigger);
      this.APIToken.refreshIdTokenTrigger = 0;
    }
  };

  _proto.tokenMissingEvent = function tokenMissingEvent() {
    this.APIToken.tokenMissing = true;
  };

  _proto.tokenExpiredEvent = function tokenExpiredEvent() {
    this.APIToken.tokenExpired = true;
  };

  _proto.unauthorizedEvent = function unauthorizedEvent() {
    this.APIToken.unauthorized = true;
  };

  _createClass(AuthenticateService, [{
    key: "_APIToken",
    get: function get() {
      return this.APIToken;
    },
    set: function set(APIToken) {
      this.APIToken = APIToken;
    }
  }]);

  return AuthenticateService;
}();

var AuthChecking = /*#__PURE__*/function () {
  function AuthChecking() {
    this.data = {
      hasValidToken: false,
      requiresAuth: false
    };
  }

  var _proto2 = AuthChecking.prototype;

  _proto2.checkValidAuth = function checkValidAuth() {
    var _this4 = this;

    var promise = new Promise(function (resolve) {
      if (_this4.data.requiresAuth === true) {
        if (_this4.data.hasValidToken === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      } else {
        resolve(true);
      }
    });
    return promise;
  };

  _createClass(AuthChecking, [{
    key: "_hasValidToken",
    get: function get() {
      return this.data.hasValidToken;
    },
    set: function set(hasValidToken) {
      this.data.hasValidToken = hasValidToken;
    }
  }]);

  return AuthChecking;
}();

var DEFAULT_CONTEXT = {
  signOut: function signOut() {},
  user: null,
  userManager: null
};
var AuthenticatorContext = createContext(DEFAULT_CONTEXT);

var authFn = /*#__PURE__*/function () {
  function authFn() {
    this.eventPrefix = 'oidcauth:';
    this.tokenExpiresSoonEvent = this.eventPrefix + 'tokenExpires';
    this.loggedInEvent = this.eventPrefix + 'loggedIn';
    this.loggedOutEvent = this.eventPrefix + 'loggedOut';
    this.silentRefreshStartedEvent = this.eventPrefix + 'silentRefreshStarted';
    this.silentRefreshSuceededEvent = this.eventPrefix + 'silentRefreshSucceded';
    this.silentRefreshFailedEvent = this.eventPrefix + 'silentRefreshFailed';
    this.silentRefreshTimeoutEvent = this.eventPrefix + 'silentRefreshTimeout';
    this.config = JSON.parse(JSON.stringify(defaultConfiguration));
    this.TokenService = new TokenService();
  }

  var _proto = authFn.prototype;

  _proto.init = function init() {
    if (localStorage.getItem('logoutActive')) {
      localStorage.removeItem('logoutActive');
      this.TokenService.clearTokens();
    }

    if (localStorage.getItem('refreshRunning')) {
      localStorage.removeItem('refreshRunning');
    }
  };

  _proto.setConfig = function setConfig(conf) {
    var newConfig = {
      redirect_uri: conf.redirect_uri,
      client_id: conf.client_id,
      authority: conf.authority,
      callbackRedirectUri: conf.redirect_uri + '/auth/callback',
      response_type: conf.response_type,
      scope: conf.scope,
      postLogoutRedirectUri: conf.authority + '/auth/clear',
      expiresInKey: conf.expiresInKey,
      hash: false,
      baseHref: ''
    };
    Object.assign(this.config, newConfig);
  };

  _proto.createLoginUrl = function createLoginUrl(nonce, state, config) {
    this.setConfig(config);
    var hasPathDelimiter = config.redirect_uri.endsWith('/');
    var appendChar = hasPathDelimiter ? '' : '/';
    var idpClaimValue;
    var currentClaims = this.TokenService.allClaims();

    if (currentClaims) {
      idpClaimValue = currentClaims['idp'];
    }

    var baseUrl = this.config.authority + appendChar;
    var url = baseUrl + this.config.authorizationEndpoint + '?response_type=' + encodeURIComponent(this.config.response_type) + '&client_id=' + encodeURIComponent(this.config.client_id) + '&state=' + encodeURIComponent(state || this.config.state) + '&redirect_uri=' + encodeURIComponent(this.config.callbackRedirectUri) + '&scope=' + encodeURIComponent(this.config.scope) + '&nonce=' + encodeURIComponent(nonce);

    if (this.config.stickToLastKnownIdp && idpClaimValue) {
      url = url + '&acr_values=' + encodeURIComponent('idp:' + idpClaimValue);
    }

    return url;
  };

  _proto.createLogoutUrl = function createLogoutUrl(conf, state) {
    var idToken = this.TokenService.getIdToken();
    this.setConfig(conf);
    var hasPathDelimiter = this.config.redirect_uri.endsWith('/');
    var appendChar = hasPathDelimiter ? '' : '/';
    var baseUrl = this.config.authority + appendChar;

    if (idToken) {
      var url = baseUrl + this.config.endSessionEndpoint + '?id_token_hint=' + encodeURIComponent(idToken) + '&post_logout_redirect_uri=' + encodeURIComponent(this.config.postLogoutRedirectUri) + '&state=' + encodeURIComponent(state || this.config.state) + '&r=' + Math.random();
      return url;
    } else {
      return this.config.redirect_uri;
    }
  };

  _proto.startImplicitFlow = function startImplicitFlow(conf, localRedirect) {
    if (localRedirect) {
      localStorage.setItem('localRedirect', localRedirect);
    } else {
      var currentPath = window.location.href;

      if (currentPath.indexOf('auth/callback') === -1 && currentPath.indexOf('auth/clear') === -1) {
        localStorage.setItem('bfLoggin', currentPath);
      }
    }

    var url = this.createLoginUrl('vrrdEd8h8NXtxMC68rQWaa8Fy4Xj4mz', '', conf);
    window.location.replace(url);
  };

  _proto.startLogout = function startLogout(conf, state) {
    var _this = this;

    var promise = new Promise(function (resolve) {
      var url = _this.createLogoutUrl(conf, state);

      window.localStorage.clear();
      localStorage.setItem('logoutActive', 'true');
      window.location.replace(url);
      resolve(url);
    });
    return promise;
  };

  _proto.trySilentRefresh = function trySilentRefresh(conf) {
    if (localStorage.getItem('refreshRunning')) {
      return;
    }

    localStorage.setItem('refreshRunning', 'true');
    window['silentRefreshStartedEvent'] = this.silentRefreshStartedEvent;
    var url = this.createLoginUrl('vrrdEd8h8NXtxMC68rQWaa8Fy4Xj4mz', 'refresh', conf);
    var ifrm = document.createElement("iframe");
    ifrm.setAttribute("src", url);
    ifrm.setAttribute("style", "height: 400px; width: 100%; display:none;visibility:hidden;");
    ifrm.id = "oauthFrame";
    document.body.appendChild(ifrm);
    setTimeout(function () {
      if (localStorage.getItem('refreshRunning')) {
        localStorage.removeItem('refreshRunning');
      }

      document.body.removeChild(ifrm);
    }, 5000);
  };

  return authFn;
}();

function makeAuthenticator(_ref) {
  var userManager = _ref.userManager,
      placeholderComponent = _ref.placeholderComponent,
      signinArgs = _ref.signinArgs,
      configuration = _ref.configuration;
  return function (WrappedComponent) {
    return /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(Authenticator, _React$Component);

      function Authenticator(props) {
        var _this2;

        _this2 = _React$Component.call(this, props) || this;
        _this2.TokenService = new TokenService();
        _this2.TokenManagerService = new TokenManagerService();
        _this2.AuthenticateService = new AuthenticateService();
        _this2.authFn = new authFn();

        _this2.getUser = function () {
          _this2.userManager.getUser().then(function (user) {
            return _this2.storeUser(user);
          })["catch"](function () {
            return _this2.setState({
              isFetchingUser: false
            });
          });
        };

        _this2.storeUser = function (user) {
          if (user) {
            _this2.setState(function (_ref2) {
              var context = _ref2.context;
              return {
                context: _extends({}, context, {
                  user: user
                }),
                isFetchingUser: false
              };
            });
          } else {
            _this2.setState(function (_ref3) {
              var context = _ref3.context;
              return {
                context: _extends({}, context, {
                  user: null
                }),
                isFetchingUser: false
              };
            });
          }
        };

        _this2.signOut = function (conf) {
          _this2.TokenManagerService.logoutFn(conf);
        };

        _this2.isValid = function () {
          var user = _this2.state.context.user;
          return !!(user && !user.expired);
        };

        _this2.configuration = Object.assign(defaultConfiguration, configuration);
        var um = userManager ? userManager : makeUserManager(_this2.configuration);
        _this2.userManager = um;
        _this2.signinArgs = {
          redirect_uri: _this2.configuration.redirect_uri + '/auth/callback'
        };
        _this2.signinArgs = Object.assign(_this2.signinArgs, signinArgs);
        _this2.state = {
          context: {
            signOut: function signOut() {
              return _this2.signOut(_this2.configuration);
            },
            user: null,
            userManager: um
          },
          isFetchingUser: true
        };
        return _this2;
      }

      var _proto2 = Authenticator.prototype;

      _proto2.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var user = localStorage.getItem('user');
        var idToken = localStorage.getItem('idToken');

        if (user !== null && idToken !== null) {
          if (!this.TokenService.hasValidToken()) {
            if (this.configuration.redirectCurrentLink) {
              var localRedirect = window.location.href;
              localStorage.setItem('localRedirect', localRedirect);
            }

            this.authFn.init();
            this.authFn.startImplicitFlow(this.configuration);
          } else {
            this.storeUser(JSON.parse(user));
            var remainTimeToRefresh;
            var timeToRefresh = JSON.parse(user).expires;
            var now = Date.now();

            if (timeToRefresh > now) {
              remainTimeToRefresh = timeToRefresh - now;
            } else if (timeToRefresh < now) {
              this.authFn.trySilentRefresh(this.configuration);
            } else {
              remainTimeToRefresh = parseInt(JSON.parse(user).expires_in) * 1000;
            }

            setInterval(function () {
              if (!_this3.TokenService.hasValidToken()) {
                _this3.AuthenticateService.triggerRegetNewIdToken(_this3.configuration);
              } else {
                _this3.authFn.trySilentRefresh(_this3.configuration);
              }
            }, remainTimeToRefresh);
          }
        } else {
          if (this.configuration.redirectCurrentLink) {
            var localRedirect = window.location.href;
            localStorage.setItem('localRedirect', localRedirect);
          }

          this.authFn.init();
          this.authFn.startImplicitFlow(this.configuration);
        }
      };

      _proto2.render = function render() {
        if (this.state.isFetchingUser) {
          return placeholderComponent || null;
        }

        return this.isValid() ? createElement(AuthenticatorContext.Provider, {
          value: this.state.context
        }, createElement(WrappedComponent, Object.assign({}, this.props))) : createElement(RedirectToAuth, {
          userManager: this.userManager,
          onSilentSuccess: this.storeUser,
          signinArgs: this.signinArgs
        }, placeholderComponent);
      };

      return Authenticator;
    }(Component);
  };
}

var Callback = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Callback, _React$Component);

  function Callback() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.TokenService = new TokenService();
    _this.AuthChecking = new AuthChecking();
    _this.AuthenticateService = new AuthenticateService();
    _this.TokenManagerService = new TokenManagerService();
    _this.eventPrefix = 'oidcauth:';
    _this.tokenExpiresSoonEvent = _this.eventPrefix + 'tokenExpires';
    _this.loggedInEvent = _this.eventPrefix + 'loggedIn';
    _this.loggedOutEvent = _this.eventPrefix + 'loggedOut';
    _this.silentRefreshStartedEvent = _this.eventPrefix + 'silentRefreshStarted';
    _this.silentRefreshSuceededEvent = _this.eventPrefix + 'silentRefreshSucceded';
    _this.silentRefreshFailedEvent = _this.eventPrefix + 'silentRefreshFailed';
    _this.silentRefreshTimeoutEvent = _this.eventPrefix + 'silentRefreshTimeout';
    return _this;
  }

  var _proto = Callback.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        userManager = _this$props.userManager,
        configuration = _this$props.configuration;
    var conf = configuration;
    var um = userManager ? userManager : makeUserManager(configuration);
    var currentPath = window.location.href;

    if (currentPath.indexOf('auth/callback') !== -1) {
      this.AuthTokenCtrlFn(conf);
    } else if (currentPath.indexOf('auth/clear') !== -1) {
      this.LogoutCtrl(conf);
    }
  };

  _proto.AuthTokenCtrlFn = function AuthTokenCtrlFn(conf) {
    var now = new Date();
    var response = window.location.hash.replace(/#/, '');
    var paramsArr = response.split('&');
    var userJson = {};
    var key, val;

    for (var i = 0; i < paramsArr.length; i++) {
      var firstOccurrenceEqual = paramsArr[i].indexOf('=');
      key = paramsArr[i].substr(0, firstOccurrenceEqual);
      val = paramsArr[i].substr(firstOccurrenceEqual + 1);

      if (key === 'expires_in') {
        userJson['expires'] = now.getTime() + parseInt(val) * 1000;
        userJson[key] = val;
      } else {
        userJson[key] = val;
      }
    }

    this.TokenManagerService.removeRefreshToken();

    if (Object.keys(userJson).length > 0) {
      localStorage.setItem('user', JSON.stringify(userJson));
      this.AuthChecking.data.hasValidToken = true;
      this.handleSignInCallback(response);
      this.AuthenticateService.triggerRenewToken(userJson['expires_in'], conf);
    } else {
      this.TokenManagerService.logoutFn(conf);

      if (conf.unauthorizeRoute !== null) {
        window.location.replace(conf.unauthorizeRoute);
      } else {
        window.location.hash.replace(/#/, '');
        window.location.replace('/');
      }
    }
  };

  _proto.handleSignInCallback = function handleSignInCallback(data) {
    localStorage.removeItem('tokenProcessing');

    if (!data && window.location.hash.indexOf('#') === 0) {
      data = window.location.hash.substr(16);
    }

    var fragments = {};

    if (data) {
      fragments = this.parseQueryString(data);
    } else {
      throw Error('Unable to process callback. No data given!');
    }

    var idToken = fragments['id_token'];
    var state = fragments['state'];

    if (idToken) {
      this.handleImplicitFlowCallback(idToken);

      if (state === 'refresh') {
        this.handleSilentRefreshCallback(idToken);
      } else {
        this.handleImplicitFlowCallback(idToken);
      }
    }
  };

  _proto.handleImplicitFlowCallback = function handleImplicitFlowCallback(idToken) {
    var _this2 = this;

    var promise = new Promise(function (resolve) {
      _this2.TokenService.saveToken(idToken);

      var localRedirect = localStorage.getItem('localRedirect');
      var loggedInEvent = 'oidcauth:loggedIn';
      resolve(loggedInEvent);
      window.location.href.split('#')[0];
      var redirectTo = '/';

      if (localRedirect) {
        redirectTo = localRedirect.substring(localRedirect.indexOf('#'));
        localStorage.removeItem('localRedirect');
      } else if (localStorage.getItem('bfLoggin')) {
        var bfLoggin = localStorage.getItem('bfLoggin');

        if (bfLoggin) {
          redirectTo = bfLoggin;
        }

        localStorage.removeItem('bfLoggin');
      }

      resolve(redirectTo);

      if (redirectTo) {
        window.location.replace(redirectTo);
      }
    });
    return promise;
  };

  _proto.handleSilentRefreshCallback = function handleSilentRefreshCallback(newIdToken) {
    localStorage.removeItem('refreshRunning');
    var currentClaims = this.TokenService.allClaims();
    var newClaims = this.TokenService.convertToClaims(newIdToken);

    if (currentClaims.exp && newClaims.exp && newClaims.exp > currentClaims.exp) {
      this.TokenService.saveToken(newIdToken);
      window['silentRefreshSuceededEvent'] = this.silentRefreshSuceededEvent;
    } else {
      window['silentRefreshFailedEvent'] = this.silentRefreshFailedEvent;
    }
  };

  _proto.parseQueryString = function parseQueryString(queryString) {
    var data = {},
        pairs,
        pair,
        separatorIndex,
        escapedKey,
        escapedValue,
        key,
        value;

    if (queryString === null) {
      return data;
    }

    pairs = queryString.split('&');

    for (var i = 0; i < pairs.length; i++) {
      pair = pairs[i];
      separatorIndex = pair.indexOf('=');

      if (separatorIndex === -1) {
        escapedKey = pair;
        escapedValue = '';
      } else {
        escapedKey = pair.substr(0, separatorIndex);
        escapedValue = pair.substr(separatorIndex + 1);
      }

      key = decodeURIComponent(escapedKey);
      value = decodeURIComponent(escapedValue);

      if (key.substr(0, 1) === '/') {
        key = key.substr(1);
      }

      data[key] = value;
    }

    return data;
  };

  _proto.LogoutCtrl = function LogoutCtrl(conf) {
    if (conf.unauthorizeRoute !== null) {
      localStorage.clear();
      window.location.replace(conf.redirect_uri + '/' + conf.unauthorizeRoute);
    } else {
      localStorage.clear();
      window.close();
    }
  };

  _proto.render = function render() {
    return this.props.children || null;
  };

  return Callback;
}(Component);

export { Callback, AuthenticatorContext as UserData, makeAuthenticator, makeUserManager };